var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Copy 1",
    width: 24,
    height: 24,
    x: 0,
    y: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M6.5 6.2158L6.5 3.90625C6.5 3.1296 7.1296 2.5 7.90625 2.5L20.0938 2.5C20.8704 2.5 21.5 3.1296 21.5 3.90625L21.5 16.0938C21.5 16.8704 20.8704 17.5 20.0938 17.5L17.7582 17.5",
    fillRule: "nonzero",
    stroke: "rgb(169,211,3)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M3.90625 6.5C3.1296 6.5 2.5 7.1296 2.5 7.90625L2.5 20.0938C2.5 20.8704 3.1296 21.5 3.90625 21.5L16.0938 21.5C16.8704 21.5 17.5 20.8704 17.5 20.0938L17.5 7.90625C17.5 7.1296 16.8704 6.5 16.0938 6.5L3.90625 6.5Z",
    fillRule: "nonzero",
    stroke: "rgb(169,211,3)",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e62c6fce71a85e5a17b68db75ec2e84d.svg";
export { ForwardRef as ReactComponent };